var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-time-picker',{staticClass:"position",attrs:{"color":_vm.color,"value":_vm.clockValue,"allowed-minutes":_vm.allowedMinutes,"width":"200","format":"24hr"},on:{"input":_vm.handleChange}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b9036d3","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/timepicker/TimePicker.vue
// module id = RfRO
// module chunks = 1